module.exports = __webpack_public_path__ + "img/E-WEB-Goal-11.6ce43a06.svg";